import { injectable } from 'inversify';
import { organisation_change_availability_full } from '@Api';
import {
  OrganisationChangeAvailability,
  OrganisationChangeAvailabilityAction,
} from '@Models';

@injectable()
export class OrganisationChangeAvailabilityMapper {
  public map(
    item: organisation_change_availability_full,
  ): OrganisationChangeAvailability {
    return {
      id: item.id,
      action: this.mapAction(item.action),
      unitOptionId: item.unit_option_id,
    } satisfies OrganisationChangeAvailability as OrganisationChangeAvailability;
  }

  public mapAction(
    item: organisation_change_availability_full.action,
  ): OrganisationChangeAvailabilityAction {
    return OrganisationChangeAvailabilityAction.Disable;
  }
}
